/**
 * Affiliate ref capture (Layer B). On any page load with ?ref=<code> we stash
 * the code (30-day TTL) so it survives the journey to signup + checkout:
 *   click ?ref=ant → localStorage → record_referral() on signup → coupon at checkout.
 */

import { supabase } from "../../supabaseClient";

const KEY = "bam_ref";
const TTL_MS = 1000 * 60 * 60 * 24 * 30; // 30 days

export function captureRefFromUrl() {
  try {
    const ref = (new URLSearchParams(window.location.search).get("ref") || "").trim().toLowerCase();
    // codes are short slugs; ignore anything weird
    if (ref && /^[a-z0-9_-]{1,40}$/.test(ref)) {
      localStorage.setItem(KEY, JSON.stringify({ ref, ts: Date.now() }));
    }
  } catch { /* ignore */ }
}

export function getStoredRef() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { ref, ts } = JSON.parse(raw);
    if (!ref || Date.now() - ts > TTL_MS) return null;
    return ref;
  } catch { return null; }
}

/** Record first-touch attribution after a successful signup (no-op if no ref). */
export async function recordReferral() {
  const ref = getStoredRef();
  if (!ref) return;
  try { await supabase.rpc("record_referral", { p_code: ref }); } catch { /* non-fatal */ }
}

/** The current coach's referral code + stats, or null if they have no link. */
export async function getMyReferralStats() {
  try {
    const { data, error } = await supabase.rpc("my_referral_stats");
    if (error) return null;
    return data?.[0] || null; // { code, signups, conversions }
  } catch { return null; }
}

/** Build the shareable referral URL for a code. */
export function referralLink(code) {
  return `https://platform.byanymeanscoaches.com/?ref=${encodeURIComponent(code)}`;
}
